import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export const StatusBadge = ({ status, className }) => {
  const statusConfig = {
    // Firm/Post statuses
    active: { label: 'Active', variant: 'default', className: 'bg-emerald-100 text-emerald-700 hover:bg-emerald-100' },
    draft: { label: 'Draft', variant: 'secondary', className: 'bg-slate-100 text-slate-700 hover:bg-slate-100' },
    hidden: { label: 'Hidden', variant: 'secondary', className: 'bg-slate-100 text-slate-700 hover:bg-slate-100' },
    published: { label: 'Published', variant: 'default', className: 'bg-emerald-100 text-emerald-700 hover:bg-emerald-100' },
    scheduled: { label: 'Scheduled', variant: 'default', className: 'bg-blue-100 text-blue-700 hover:bg-blue-100' },
    
    // Review statuses
    pending: { label: 'Pending', variant: 'default', className: 'bg-amber-100 text-amber-700 hover:bg-amber-100' },
    approved: { label: 'Approved', variant: 'default', className: 'bg-emerald-100 text-emerald-700 hover:bg-emerald-100' },
    rejected: { label: 'Rejected', variant: 'destructive', className: 'bg-red-100 text-red-700 hover:bg-red-100' },
    flagged: { label: 'Flagged', variant: 'destructive', className: 'bg-red-100 text-red-700 hover:bg-red-100' },
    
    // Payout statuses
    verified: { label: 'Verified', variant: 'default', className: 'bg-emerald-100 text-emerald-700 hover:bg-emerald-100' },
    
    // Unlisted firm statuses
    unlisted: { label: 'Unlisted', variant: 'secondary', className: 'bg-slate-100 text-slate-700 hover:bg-slate-100' },
    warning: { label: 'Warning', variant: 'default', className: 'bg-amber-100 text-amber-700 hover:bg-amber-100' },
    delisted: { label: 'Delisted', variant: 'destructive', className: 'bg-red-100 text-red-700 hover:bg-red-100' },
    
    // Announcement statuses
    live: { label: 'Live', variant: 'default', className: 'bg-emerald-100 text-emerald-700 hover:bg-emerald-100' },
    expired: { label: 'Expired', variant: 'secondary', className: 'bg-slate-100 text-slate-700 hover:bg-slate-100' },
    removed: { label: 'Removed', variant: 'destructive', className: 'bg-red-100 text-red-700 hover:bg-red-100' },
  };

  const config = statusConfig[status?.toLowerCase()] || statusConfig.active;

  return (
    <Badge
      variant={config.variant}
      className={cn(config.className, 'text-xs font-medium', className)}
    >
      {config.label}
    </Badge>
  );
};
